import { clampNegativeToZero } from '@utils/valueTransformers';
import { SplineChartWithHeaderProps } from '../components/Summary/SplineChartWithHeader';

export const reportsToSeriesData = <T extends { reportDate: string }>(options: {
  reports: T[];
  valueGetter: (report: T) => number | null;
}): SplineChartWithHeaderProps['data'] =>
  options.reports
    .map(report => ({
      date: report.reportDate,
      value: clampNegativeToZero(options.valueGetter(report) ?? 0),
    }))
    .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
